import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api, money, fdate } from "@/lib/api";
import { PageHeader, StatusBadge, TableWrap, Th, Td, Empty } from "@/components/common";
import { Button } from "@/components/ui/button";

const FILTERS = [["", "Tous"], ["brouillon", "Brouillons"], ["soumis", "À valider"], ["approuve", "Validés"], ["rejete", "Rejetés"], ["commande", "En commande"]];

export default function Quotes() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/quotes", { params: filter ? { status: filter } : {} }).then((r) => setItems(r.data));
  }, [filter]);

  return (
    <div>
      <PageHeader kicker="Gestion commerciale" title="Devis">
        <Button data-testid="new-quote-btn" onClick={() => navigate("/devis/nouveau")} className="bg-red-600 hover:bg-red-700">
          <Plus className="mr-1 h-4 w-4" /> Nouveau devis
        </Button>
      </PageHeader>
      <div className="mb-4 flex flex-wrap gap-2">
        {FILTERS.map(([v, l]) => (
          <button
            key={v}
            data-testid={`quote-filter-${v || "all"}`}
            onClick={() => setFilter(v)}
            className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${filter === v ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-400"}`}
          >
            {l}
          </button>
        ))}
      </div>
      {items.length ? (
        <TableWrap>
          <thead><tr><Th>N°</Th><Th>Client</Th><Th>Objet</Th><Th>Date</Th><Th className="text-right">Total TTC</Th><Th>Statut</Th></tr></thead>
          <tbody>
            {items.map((q) => (
              <tr key={q.id} className="cursor-pointer transition-colors hover:bg-slate-50" onClick={() => navigate(`/devis/${q.id}`)} data-testid={`quote-row-${q.number}`}>
                <Td className="font-mono text-xs"><Link to={`/devis/${q.id}`}>{q.number}</Link></Td>
                <Td className="font-medium">{q.client_name}</Td>
                <Td className="max-w-xs truncate text-slate-600">{q.object}</Td>
                <Td>{fdate(q.created_at)}</Td>
                <Td className="text-right font-semibold">{money(q.total)}</Td>
                <Td><StatusBadge status={q.status} /></Td>
              </tr>
            ))}
          </tbody>
        </TableWrap>
      ) : <Empty testId="quotes-empty" text="Aucun devis pour ce filtre." />}
    </div>
  );
}
